<!--
 * @Author: your name
 * @Date: 2021-06-24 14:52:41
 * @LastEditTime: 2021-07-26 20:03:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\RegionalPosition.vue
-->
<!--区域位置设置-->

<template>
  <div class="regional-position">
    <div class="flex-b-c label-box">
      <div class="flex-b-c">
        <div class="label-width flex-c-c">W</div>
        <el-input-number
          size="mini"
          @change="rpChange"
          v-model="rp.w"
          :precision="0"
          :min="10"
          :max="win.w-rp.x"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="flex-b-c">
        <div class="label-width flex-c-c">H</div>
        <el-input-number
          size="mini"
          @change="rpChange"
          v-model="rp.h"
          :precision="0"
          :min="10"
          :max="win.h-rp.y"
          style="width: 100px"
        ></el-input-number>
      </div>
    </div>
    <div class="flex-b-c label-box">
      <div class="flex-b-c">
        <div class="label-width flex-c-c">X</div>
        <el-input-number
          size="mini"
          @change="rpChange"
          v-model="rp.x"
          :precision="0"
          :min="0"
          :max="win.w-rp.w"
          style="width: 100px"
        ></el-input-number>
      </div>
      <div class="flex-b-c">
        <div class="label-width flex-c-c">Y</div>
        <el-input-number
          size="mini"
          @change="rpChange"
          v-model="rp.y"
          :precision="0"
          :min="0"
          :max="win.h-rp.h"
          style="width: 100px"
        ></el-input-number>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegionalPosition",
  inject: {
    vdrInfor: {
      type: Object,
      default: () => { }
    }
  },
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      rp: {
        w: 0,
        h: 0,
        x: 0,
        y: 0
      },
      win: {}
    }
  },
  mounted() {
    const { w, h } = this.vdrInfor;
    this.win = { w: parseInt(w), h: parseInt(h) };
  },
  methods: {
    rpChange() {
      // console.log(this.rp);
      let { w, h, x, y } = this.rp;
      this.setRegional(x, y, w, h);
    },
    rpInit() {
      for (const key in this.rp) {
        if (Object.hasOwnProperty.call(this.rp, key)) {
          this.rp[key] = this.media[key];
        }
      }
      // console.log(this.rp);
    },
    // 设置窗口大小
    setRegional(x, y, w, h) {
      this.vdrList[this.vdrIndex].x = parseInt(x);
      this.vdrList[this.vdrIndex].y = parseInt(y);
      this.vdrList[this.vdrIndex].w = parseInt(w);
      this.vdrList[this.vdrIndex].h = parseInt(h);
      this.vdrList[this.vdrIndex].wicket.forEach(wicket => {
        wicket.w = this.vdrList[this.vdrIndex].w;
        wicket.h = this.vdrList[this.vdrIndex].h;
      });
      // this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);.
    },
  },
  computed: {
    ratio() {
      return this.$store.state.program.ratio;
    },
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrIndex() {
      return this.$store.state.program.vdrIndex;
    }
  },
  watch: {
    media: {
      handler() {
        this.rpInit();
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.regional-position {
  .label-box {
    padding: 10px 0px;
    padding-right: 4px;
    .label-width {
      width: 20px;
      color: #617883;
    }
  }
}
</style>